module.exports = __webpack_public_path__ + "img/PS38.eef8be1d.png";